import styled from 'styled-components';
import tw from 'twin.macro';

export const BadgeStyled = styled.span`
  ${tw`rounded-md py-1 px-2 mb-2 md:mb-0 mr-2 whitespace-nowrap text-xs capitalize`};
  ${tw`text-gray-200 border border-gray-200`};
  font-size: 11px;
`;
